import Report from './report'
import requireAuth from '../../require-auth'

export default requireAuth(Report)



// WEBPACK FOOTER //
// ./src/components/pages/report/index.ts